module.exports = __webpack_public_path__ + "static/media/callout-icon.88116307.svg";